import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/holidays/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/holidays/create', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/holidays/delete/${id}`)
}
